import React from 'react'

export const Titles = ({ text = 'Sign up as an event organizer' }) => (
  <>
    <div className="get-started-label">Let’s get you started</div>
    <div className="instruction-label">{text}</div>
  </>
)
